module.exports = __webpack_public_path__ + "img/forest-fall.42549457.webp";